import {
  getTheoPlayerImportSource,
  getTHEOplayerRuntime,
} from "./theoplayerRuntime";

import type Component from "video.js/dist/types/component";

type TheoPlayerRuntime = ReturnType<typeof getTHEOplayerRuntime>;

export const getVideoJsComponent = (
  componentName:
    | "Button"
    | "FullscreenToggle"
    | "Component"
    | "MenuButton"
    | "MenuItem"
): typeof Component => {
  const { THEOplayer: THEOplayerFromWindow } = window;
  const importSource = getTheoPlayerImportSource();
  const THEOplayer: TheoPlayerRuntime =
    importSource === "node-module"
      ? getTHEOplayerRuntime()
      : (THEOplayerFromWindow as TheoPlayerRuntime);

  const VideoJsComponent = THEOplayer.videojs.getComponent(componentName);

  return VideoJsComponent;
};
